<template>
  <v-chip
    v-if="statusLabel"
    size="small"
    :color="chipColor"
    rounded="pill"
    :text="statusLabel"
  />
</template>

<script lang="ts" setup>
import { computed } from 'vue'
import { useI18n } from 'vue-i18n'

type Status = 'not-connected' | 'link-connected' | 'link-active'

const props = withDefaults(
  defineProps<{
    status: Status
    namespace?: 'proven-expert' | 'google-reviews'
  }>(),
  {
    namespace: 'proven-expert',
  }
)

const { t } = useI18n()

const statusLabel = computed(() => {
  return t(`connection-manager.${props.namespace}.status.${props.status}`)
})

const chipColor = computed(() => {
  if (props.status === 'link-active') {
    return 'green-lighten-1'
  }
  if (props.status === 'link-connected') {
    return 'blue-grey-lighten-4'
  }
  return 'grey-lighten-2'
})
</script>
